import { paymentDeleteApi } from "../../api/payment/paymentDeleteApi"

type PayloadShape = Parameters<typeof paymentDeleteApi>[0]

export async function paymentDeleteService(payload: PayloadShape, token: string) {
	return await paymentDeleteApi(payload, token)
}
